import {Component} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {FormBuilder} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AngularFireDatabase} from 'angularfire2/database';
import {Observable} from 'rxjs/Observable';
import { environment } from '@env/environment';
import {PlaceServiceBase} from '@app/core/places.service';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';

@Component({
  selector: 'app-shopping-promotion-lottery',
  templateUrl: './shopping-promotion-lottery.component.html',
  styleUrls: ['./shopping-promotion-lottery.component.scss']
})
export class ShoppingPromotionLotteryComponent {
  promotion: ShoppingPromotionModel;
  promotionId: string;
  shoppingid: string;
  realtimeData: Observable<any[]>;
  dozens: any[];
  isWinner: boolean;
  originalNumbers: string;
  userCoupons: string[];
  possibleCoupons: string[];
  impossibleCoupons: string[];
  possibleWinners: string;

  hours = 0;
  minutes = 0;
  seconds = 0;
  countDownTimeLottery = 0;

  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;

  constructor(private formBuilder: FormBuilder,
              private shoppingService: ShoppingService,
              private chainService: ChainService,
              private domainService: DomainService,
              private modalService: NgbModal,
              private router: Router,
              private route: ActivatedRoute,
              private db: AngularFireDatabase) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.route.params.subscribe( params => {
      this.promotionId = params.promotionId;
      this.shoppingid = params.shoppingId;

      this.loadShoppingPromotion(this.promotionId);
    } );
  }

  isLotteryVideo(url: string) {
    if (url.indexOf('http') !== -1) {
      return false;
    }
    return true;
  }

  calculateCountdown(totalSeconds: number) {
    this.hours = Math.floor(totalSeconds / 3600);
    this.minutes = Math.floor(totalSeconds % 3600 / 60);
    this.seconds = Math.floor(totalSeconds % 3600 % 60);
  }

  loadShoppingPromotion(promotionId: string) {
    this.placeService.getPromotion(promotionId)
      .pipe(finalize(() => {
      }))
      .subscribe(promotion => {
        this.promotion = promotion;
        this.countDownTimeLottery = promotion.countDownTimeLottery;

        setInterval(() => {
          this.countDownTimeLottery--;
          this.calculateCountdown(this.countDownTimeLottery);
        }, 1000);

        this.dozens = new Array(5);
        this.realtimeData = this.db.list(`${environment.firebaseEnv}/wynk/promotion/${promotion.id}`).valueChanges();
        this.realtimeData.subscribe((arrayData) => {
          //console.log('alterou dados!', arrayData);
          const arraySize = 5;
          this.dozens = new Array(arraySize);
          this.possibleWinners = arrayData[1].toString();

          const hashStore = '##############';
          const originalNumbers = arrayData[0];
          const final = hashStore.substring(0, arraySize - originalNumbers.length) + originalNumbers;
          const dozens = final.split('');

          this.originalNumbers = originalNumbers;
          this.promotion.status = arrayData[2];
          for (let a = arraySize - 1; a >= 0; a--) {
            if (dozens[a] === '#') {
              this.dozens[a] = null;
              continue;
            }
            this.dozens[a] = dozens[a];
          }

          this.placeService.getLotteryUserCoupons(this.promotionId).subscribe(userCoupons => {
            console.log(userCoupons);
            if (!userCoupons || !userCoupons.map) {
              return;
            }
            this.userCoupons = userCoupons.map(coupomObj => coupomObj.code.toString());
            console.log('userCoupons', this.userCoupons);
            this.possibleCoupons = this.userCoupons.filter(coupom => coupom.match(originalNumbers + '$'));
            this.impossibleCoupons = this.userCoupons.filter(coupom => !coupom.match(originalNumbers + '$'));
            this.isWinner = this.userCoupons.some(coupom => coupom === originalNumbers);
          });
          console.log(this.dozens);
          console.log(arrayData);
        });

      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }

  openPromotionsPage() {
    const link = `/shopping/${this.shoppingid}/promotions`;
    this.router.navigate([link]);
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-promotion-lottery/shopping-promotion-lottery.component.ts